import { Injectable } from '@angular/core';
import { GeocoderResponse } from '../models/util.models';

@Injectable({
  providedIn: 'root',
})
export class GeocodingService {

  geocodeLatLng(location: google.maps.LatLngLiteral): Promise<GeocoderResponse> {
    let geocoder = new google.maps.Geocoder();

    return new Promise((resolve, reject) => {
      geocoder.geocode({ 'location': location }, (results, status) => {
        const response = new GeocoderResponse(status, results);
        resolve(response);
      });
    });
  }

}
